// extracted by mini-css-extract-plugin
export default {"layout":"xcyKh","wrapper":"FMemQ","content":"cEpeP"};